import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["type", "icon", "label", "color", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Tooltip from './Tooltip';
import Component from '../Component';
import classList from '../utils/classList';
import textContrastClass from '../helpers/textContrastClass';
import Icon from './Icon';
/**
 * The `Badge` component represents a user/discussion badge, indicating some
 * status (e.g. a discussion is stickied, a user is an admin).
 *
 * A badge may have the following special attrs:
 *
 * - `type` The type of badge this is. This will be used to give the badge a
 *   class name of `Badge--{type}`.
 * - `icon` The name of an icon to show inside the badge.
 * - `label`
 *
 * All other attrs will be assigned as attributes on the badge element.
 */
export default class Badge extends Component {
  view() {
    const _this$attrs = this.attrs,
      {
        type,
        icon: iconName,
        label,
        color,
        style = {}
      } = _this$attrs,
      attrs = _objectWithoutProperties(_this$attrs, _excluded);
    const className = classList('Badge', [type && "Badge--".concat(type)], attrs.className, textContrastClass(color));
    const iconChild = iconName ? m(Icon, {
      name: iconName,
      className: "Badge-icon"
    }) : m.trust('&nbsp;');
    const newStyle = _objectSpread({}, style);
    if (!window.testing) {
      newStyle['--badge-bg'] = color;
    }
    const badgeAttrs = _objectSpread(_objectSpread({}, attrs), {}, {
      className,
      style: newStyle
    });
    const badgeNode = m("div", badgeAttrs, iconChild);

    // If we don't have a tooltip label, don't render the tooltip component.
    if (!label) return badgeNode;
    return m(Tooltip, {
      text: label
    }, badgeNode);
  }
}
flarum.reg.add('core', 'common/components/Badge', Badge);